import { pdf } from "@react-pdf/renderer";
import { LeadFoodMenuEjs } from "../LeadFoodMenuEjs";

// Sample product data based on your image

export const generateAndDownloadPdf = async (previewData: any) => {
  const blob = await pdf(<LeadFoodMenuEjs data={previewData} />).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Lead-Food-Menu.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const generatePdfFile = async (previewData: any): Promise<File> => {
  const blob = await pdf(<LeadFoodMenuEjs data={previewData} />).toBlob();

  const file = new File([blob], "Lead-Food-Menu.pdf", {
    type: "application/pdf",
  });

  return file;
};
